import { api } from "../../Config/ApiConfig";


export const login = async (credentials) => {
  const { data } = await api.post('/auth/login', credentials);
  return data;
};

export const loginWithFacebook = async (access_token) => {
  const { data } = await api.post('/auth/facebook-login', { access_token });
  return data;
};

